import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    informeAlcance: [],
  },

  getters: {
    getInformeAlcance: (state) => state.informeAlcance,
  },

  mutations: {
    SET_INFORME_ALCANCE(state, informeAlcance) {
      state.informeAlcance = informeAlcance;
    },
  },

  actions: {
    async fetchInformeAlcance({ commit }) {
      axios
        .get('')
        .then((response) => {
          commit('SET_INFORME_ALCANCE', response.data.data);
        });
    },

    async saveInformeAlcance(context, informeAlcance) {
      await axios
        .post(
          `PoliciaCuadrantes/C3/expedientes/${
            informeAlcance.idExpediente
          }/evaluacionesise/${
            informeAlcance.idEvaluacionIse
          }/informeAlcance`,
          informeAlcance,
        )
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Informe de alcance guardado correctamente.', {
            root: true,
          });
        });
    },

    async updateInformeAlcance(_, informeAlcance) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/expedientes/${
            informeAlcance.idExpediente
          }/evaluacionesise/${
            informeAlcance.idEvaluacionIse
          }/informeAlcance/${
            informeAlcance.idInformeAlcance}`,
          informeAlcance,
        );
    },
  },
};
